













import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class ComponentsLis extends Vue {
  @Emit("close")
  private close() {}
}
